import {
  chainReducers,
  createApiReducer,
  INITIAL_API_STATE,
} from "services/api";
import { LanguageActionTypes } from "./actions";
import { transformLanguage } from "../transformation";


const fetchLanguageReducer = createApiReducer(
  [
    LanguageActionTypes.FETCH_LANGUAGES_START,
    LanguageActionTypes.FETCH_LANGUAGES_SUCCESS,
    LanguageActionTypes.FETCH_LANGUAGES_FAILURE,
  ],
  (data) => {
    return {
      items: data.map(transformLanguage),
    };
  },
  (data) => {
    return data;
  }
);

const languageChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchLanguageReducer
);

export default languageChainedReducers;
